import { useContext } from "react";
import { VideoPlaybackContext } from "../../components/VideoPlaybackProvider/VideoPlaybackProvider";
import { PlaybackContextType } from "../../types/playback-provider";

export const useVideoPlaybackContext = (): PlaybackContextType => {
	const context = useContext(VideoPlaybackContext);
	if (!context) {
		throw new Error("useVideoPlaybackContext must be used within a VideoPlaybackProvider");
	}
	return context;
}